import React from "react";
import PropTypes from "prop-types";
import { Table, TableHeader, TableBody, TableRow, TableHeaderCell, TableCell, Box } from "@sainsburys-tech/fable";
import moment from "moment";
import { Link } from "react-router-dom";
import OverrideStageIcon from "../OverrideStageIcon";
import { Button } from "@sainsburys-tech/fable";
import overrideStageIsValidForDiscard from "../../model/lighting-overrides/overrideStageIsValidForDiscard";
import WhenAuthorized from "../WhenAuthorized";
import * as roles from "../../utils/roles";
import * as overrideStages from "../../model/lighting-overrides/overrideStageKeys";
import MultiStoreOverrideStatus from "../MultiStoreOverrideStatus";

const sortTimeInMilliseconds = (accessor, ascending) => (a, b) => {
  const Item1valueA = parseInt(accessor(a).timeInMilliseconds, 0);
  const Item2valueA = parseInt(accessor(b).timeInMilliseconds, 0);
  if (Item1valueA < Item2valueA) {
    return ascending ? -1 : 1;
  }
  if (Item1valueA > Item2valueA) {
    return ascending ? 1 : -1;
  }
  return 0;
};

const OverridesListTable = props => (
  <Box>
    <Table isResponsive={true} layout="fixed">
      <TableHeader>
        <TableRow>
          <TableHeaderCell>Name</TableHeaderCell>
          <TableHeaderCell>Store(s)</TableHeaderCell>
          <TableHeaderCell>Start time & date</TableHeaderCell>
          <TableHeaderCell>End time & date</TableHeaderCell>
          <TableHeaderCell>Date Added</TableHeaderCell>
          <TableHeaderCell>Status</TableHeaderCell>
          <TableHeaderCell>Actions</TableHeaderCell>
        </TableRow>
      </TableHeader>
      <TableBody>
        {props.data.map((data, index) => (
          <TableRow key={index}>
            <TableCell className="cb-c-overrides-list__overrides-table__name-column">
              {overrideStageIsValidForDiscard(data.overrideStages) &&
              data.stores.length > 1 ? (
                <Link
                  to={{
                    pathname: `/lighting/overrides/${data.overrideId}`
                  }}
                >
                  {data.name}
                </Link>
              ) : (
                data.name
              )}
            </TableCell>
            <TableCell className="cb-c-overrides-list__overrides-table__storename-column">
              {data.stores.length === 1
                ? data.stores.map(item => {
                    return item.name;
                  })
                : data.stores.length}
            </TableCell>
            <TableCell className="cb-c-overrides-list__overrides-table__date-time-column">
              {new moment(data.start).format("HH:mm") +
                " - " +
                new moment(data.start).format("DD/MM/YY")}
            </TableCell>
            <TableCell className="cb-c-overrides-list__overrides-table__date-time-column">
              {new moment(data.end).format("HH:mm") +
                " - " +
                new moment(data.end).format("DD/MM/YY")}
            </TableCell>
            <TableCell className="cb-c-overrides-list__overrides-table__date-time-column">
              {new moment(data.created).format("DD/MM/YY")}
            </TableCell>
            <TableCell>
              {data.overrideStages.length === 1 ? (
                <span className="fable:flex fable:items-center">
                  <span className="fable:mr-2">
                    <OverrideStageIcon
                      stage={data.overrideStages[0].stage.name}
                    />
                  </span>
                  {data.overrideStages[0].stage.description}
                </span>
              ) : (
                <span className="fable:flex fable:items-center">
                  {data.overrideStages.filter(
                    x =>
                      x.stage.description === overrideStages.DISCARDED ||
                      x.stage.description === overrideStages.DISCARDING
                  ).length >= 1 ? (
                    <MultiStoreOverrideStatus
                      stages={data.overrideStages}
                      currentStage={overrideStages.DISCARDED}
                    />
                  ) : (
                    <MultiStoreOverrideStatus
                      stages={data.overrideStages}
                      currentStage={overrideStages.COMPLETED}
                    />
                  )}
                </span>
              )}
            </TableCell>
            <TableCell>
              {data.overrideStages.length >= 1 ? (
                overrideStageIsValidForDiscard(data.overrideStages) ? (
                  <div className="fable:flex fable:items-center">
                    <WhenAuthorized roles={[roles.LIGHTING_OVERRIDES_WRITE]}>
                      <span className="fable:pr-16">
                        <Button onClick={() => props.onDiscardClick(data)}>
                          Discard
                        </Button>
                      </span>
                      {data.overrideStages.length === 1 && (
                        <span>
                          <Button
                            onClick={() => props.onEditClick(data.overrideId)}
                          >
                            Edit
                          </Button>
                        </span>
                      )}
                    </WhenAuthorized>
                  </div>
                ) : null
              ) : (
                ""
              )}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </Box>
);
OverridesListTable.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      overideId: PropTypes.string,
      name: PropTypes.string,
      start: PropTypes.Date,
      end: PropTypes.Date,
      stores: PropTypes.arrayOf(
        PropTypes.shape({
          storeId: PropTypes.string,
          name: PropTypes.string,
          otherName: PropTypes.string,
          region: PropTypes.string
        })
      ),
      zones: PropTypes.arrayOf(
        PropTypes.shape({
          zoneId: PropTypes.string,
          zoneRef: PropTypes.string,
          name: PropTypes.string,
          isSystemZone: PropTypes.bool
        })
      ),
      scene: PropTypes.shape({
        name: PropTypes.string,
        description: PropTypes.string,
        luxBandsAreEnabled: PropTypes.bool
      }),
      created: PropTypes.Date
    })
  ),
  onDiscardClick: PropTypes.func.isRequired
};
export default OverridesListTable;
